import { graphql, useStaticQuery } from 'gatsby';

export function getAllEvents() {
  const data = useStaticQuery(graphql`
    query {
      umbraco {
        allDswEvent(orderBy: startDate_ASC) {
          items {
            title
            subtitle
            description
            featuredImage {
              url
            }
            url
            startDate
            endDate
            videoUrl
            registerLink {
              name
              url
              target
            }
            dswSportsCategory
            dswFitnessTypes
            dswEventType
            isActiveFun
            hideDate
            eventContactName
            eventContactEmail
            eventContactPhone
            eventWebsite
            metadataTitle
            metadataDescription
            metadataKeywords
            socialMediaImage {
              url
            }
          }
        }
      }
    }
  `);

  return data?.umbraco?.allDswEvent?.items || [];
}
